import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { catchError, throwError } from "rxjs";
import { environment } from "@environments/environment";

interface EndpointNotFoundErrorBody {
  message?: string;
  code?: string;
}

function hasEndpointNotFoundMetadata(errorBody: unknown): errorBody is EndpointNotFoundErrorBody {
  if (!errorBody || typeof errorBody !== "object") {
    return false;
  }

  const candidate: EndpointNotFoundErrorBody = errorBody as EndpointNotFoundErrorBody;
  return (
    (typeof candidate.message === "string" && candidate.message.includes("endpoint not found")) ||
    candidate.code === "ENDPOINT_NOT_FOUND"
  );
}

function isEndpointNotFound(error: HttpErrorResponse): boolean {
  const errorBody: unknown = error.error;

  //Error HTML con "Cannot POST/GET/PUT/DELETE" //TODO: VERIFICAR MAS METODOS
  if (typeof errorBody === "string" && errorBody.includes("Cannot POST")) {
    return true;
  }

  if (hasEndpointNotFoundMetadata(errorBody)) {
    return true;
  }

  if (
    typeof errorBody === "string" && (errorBody.includes("Cannot") ||
    errorBody.includes("Not Found"))
  ) {
    return true;
  }

  return false;
}

function shouldFallback(error: HttpErrorResponse, request: HttpRequest<unknown>): boolean {
  return error.status === 404 && request.url.includes(environment.apiv2Url) && isEndpointNotFound(error);
}

export const fallbackApiInterceptor: HttpInterceptorFn = (request, next) =>
  next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (shouldFallback(error, request)) {
        const fallbackUrl: string = request.url.replace(environment.apiv2Url, environment.apiUrl);
        return next(request.clone({ url: fallbackUrl }));
      }

      return throwError(() => error);
    }),
  );
